import { openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/equipmentLive/open.png';
import _imports_1 from '@/assets/img/equipmentLive/close.png';
import _imports_2 from '../../../assets/img/equipmentLive//device_logo.png';
import _imports_3 from '@/assets/img/equipmentLive/star-active.png';
import _imports_4 from '@/assets/img/equipmentLive/star.png';
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-0497fb3b"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "flex align-center mb-2"
};
var _hoisted_2 = {
  key: 0,
  src: _imports_0
};
var _hoisted_3 = {
  key: 1,
  src: _imports_1
};
var _hoisted_4 = {
  class: "ml-2 title"
};
var _hoisted_5 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "flex align-center justify-between"
  }, [/*#__PURE__*/_createElementVNode("div"), /*#__PURE__*/_createElementVNode("img", {
    class: "avatar",
    src: _imports_2
  })], -1);
});
var _hoisted_6 = {
  key: 0,
  src: _imports_3
};
var _hoisted_7 = {
  key: 1,
  src: _imports_4
};
var _hoisted_8 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("h2", null, "收藏设备,设置告警值", -1);
});
var _hoisted_9 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "MM", -1);
});
var _hoisted_10 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "A", -1);
});
var _hoisted_11 = {
  style: {
    "margin": "16px"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_van_field = _resolveComponent("van-field");
  var _component_van_cell_group = _resolveComponent("van-cell-group");
  var _component_van_button = _resolveComponent("van-button");
  var _component_van_form = _resolveComponent("van-form");
  var _component_van_popup = _resolveComponent("van-popup");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", {
    class: "list-item",
    onClick: _cache[1] || (_cache[1] = function () {
      var _ctx$item$currentWarn, _ctx$item$vrmWarnValu;
      return _ctx.toCurve({
        deviceId: _ctx.item.deviceId,
        index: _ctx.index,
        currentWarnValue: (_ctx$item$currentWarn = _ctx.item.currentWarnValue) !== null && _ctx$item$currentWarn !== void 0 ? _ctx$item$currentWarn : '',
        vrmWarnValue: (_ctx$item$vrmWarnValu = _ctx.item.vrmWarnValue) !== null && _ctx$item$vrmWarnValu !== void 0 ? _ctx$item$vrmWarnValu : '',
        factoryId: _ctx.item.factoryId
      });
    })
  }, [_createElementVNode("div", _hoisted_1, [_ctx.item.status === '0' ? (_openBlock(), _createElementBlock("img", _hoisted_2)) : (_openBlock(), _createElementBlock("img", _hoisted_3)), _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.item.deviceName), 1)]), _hoisted_5, _createElementVNode("div", {
    class: "star",
    onClick: _cache[0] || (_cache[0] = _withModifiers(
    //@ts-ignore
    function () {
      return _ctx.updateFocusAsync && _ctx.updateFocusAsync.apply(_ctx, arguments);
    }, ["stop"]))
  }, [_ctx.item.isShow == '1' ? (_openBlock(), _createElementBlock("img", _hoisted_6)) : (_openBlock(), _createElementBlock("img", _hoisted_7))])]), _createVNode(_component_van_popup, {
    show: _ctx.showDialog,
    "onUpdate:show": _cache[4] || (_cache[4] = function ($event) {
      return _ctx.showDialog = $event;
    }),
    round: ""
  }, {
    default: _withCtx(function () {
      return [_hoisted_8, _createVNode(_component_van_form, {
        "validate-first": "",
        onSubmit: _ctx.onSubmit,
        style: {
          "width": "90vw"
        }
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_van_cell_group, {
            inset: ""
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_van_field, {
                modelValue: _ctx.vrmWarnValue,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
                  return _ctx.vrmWarnValue = $event;
                }),
                name: "震动告警阈值",
                label: "震动告警阈值",
                placeholder: "震动告警阈值",
                border: "",
                rules: [{
                  pattern: _ctx.pattern,
                  required: true,
                  message: '请正确填写震动告警阈值'
                }]
              }, {
                extra: _withCtx(function () {
                  return [_hoisted_9];
                }),
                _: 1
              }, 8, ["modelValue", "rules"]), _createVNode(_component_van_field, {
                modelValue: _ctx.currentWarnValue,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) {
                  return _ctx.currentWarnValue = $event;
                }),
                name: "电流告警阈值",
                label: "电流告警阈值",
                placeholder: "电流告警阈值",
                border: "",
                rules: [{
                  pattern: _ctx.pattern,
                  required: true,
                  message: '请正确填写电流告警阈值'
                }]
              }, {
                extra: _withCtx(function () {
                  return [_hoisted_10];
                }),
                _: 1
              }, 8, ["modelValue", "rules"])];
            }),
            _: 1
          }), _createElementVNode("div", _hoisted_11, [_createVNode(_component_van_button, {
            round: "",
            block: "",
            type: "primary",
            "native-type": "submit"
          }, {
            default: _withCtx(function () {
              return [_createTextVNode(" 收藏并设置 ")];
            }),
            _: 1
          })])];
        }),
        _: 1
      }, 8, ["onSubmit"])];
    }),
    _: 1
  }, 8, ["show"])], 64);
}